
<div class="dialog-wrapper">
    <div class="dailog-heding">
        <h1 mat-dialog-title>{{'delivery.tools.notepad' | translate}}</h1>
        <button (click)="closeP()" class="btn-close" aria-label="close button">
            X </button>
    </div>
    <div class="notepad-container">
        <form [formGroup]="form">
            <div class="editor">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                </ngx-editor-menu>
                <ngx-editor [editor]="editor" placeholder="{{'delivery.tools.placeHolder' | translate}}" formControlName="editorContent">
                </ngx-editor>
            </div>
        </form>
    </div>
</div>
